import React, { memo, forwardRef } from "react";
const SvgNumberfour = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M17.48 11.78h-.04l-4.12 5.9h4.16v-5.9zm3.34 5.9c.253 0 .46.04.62.12.16.08.28.173.36.28.08.107.133.22.16.34.027.107.04.2.04.28 0 .08-.013.18-.04.3a.883.883 0 01-.16.34c-.08.107-.2.2-.36.28-.16.08-.367.12-.62.12h-.98v1.82c0 .28-.047.507-.14.68-.08.16-.18.287-.3.38a.908.908 0 01-.4.18c-.133.04-.247.06-.34.06-.107 0-.227-.02-.36-.06a.906.906 0 01-.38-.18 1.306 1.306 0 01-.32-.38c-.08-.173-.12-.4-.12-.68v-1.82h-5.16c-.333 0-.6-.047-.8-.14-.2-.107-.36-.227-.48-.36a1.36 1.36 0 01-.22-.44c-.04-.16-.06-.293-.06-.4 0-.16.027-.34.08-.54.067-.2.187-.42.36-.66l5.52-7.84c.307-.44.593-.72.86-.84.28-.12.533-.18.76-.18.12 0 .267.02.44.06.173.04.333.127.48.26.16.12.293.3.4.54.12.227.18.533.18.92v7.56h.98z"
      />
    </svg>
  );
});
SvgNumberfour.displayName = "SvgNumberfour";
const MemoForwardRef = memo(SvgNumberfour);
export default MemoForwardRef;
